import { WarningOutlined } from '@ant-design/icons'
import { NavLink } from 'react-router-dom'

import type { IStorageWarning } from '@services/storage-health.service'
import { ToolTip } from '@ui/index'

import css from './ui.module.scss'


export const StorageWarningNav = ({warnings}: {warnings: IStorageWarning[]}) => {
    if (warnings.length === 0) return null

    const affectedDisks = warnings
        .map(({serverName, storageName}) => `${serverName}: ${storageName.toLocaleLowerCase('ru-RU')}`)
        .join(', ')
    const warningText = `Мало места на дисках: ${affectedDisks}. Открыть страницу «Система»`

    return <>
        <ToolTip placement='right' title={warningText}>
            <NavLink
                to='/lk/systems'
                aria-label={warningText}
                className={({isActive}) => [
                    css.nav_button,
                    css.nav_button_warning,
                    isActive ? css.nav_button_active : '',
                ].filter(Boolean).join(' ')}
            >
                <WarningOutlined />
            </NavLink>
        </ToolTip>

        <div role='separator' className={css.nav_divider} />
    </>
}